import React from 'react'

import slug from 'limax';

import PortalModal from "./PortalModal"
import Backend from "../../utils/Backend";
import ConfirmModal from "./ConfirmModal";
import General from "../../utils/General";
import Dropdown from "../Dropdown";
import Website from "../../utils/Website";
import Notify from "../../utils/Notify";
import Navigation from "../../utils/Navigation";
import {RotatingLines} from "react-loader-spinner";

const STATUSES = [
  {
    label: "Live",
    value: true
  },
  {
    label: "Draft (Not Live)",
    value: false
  }
]

const ADD_TO_MENU_OPTIONS = [
  {
    label: "Yes",
    value: true
  },
  {
    label: "No",
    value: false
  }
]

export default class PageModal extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      show: props.show,
      website: window.CURRENT_WEBSITE,
      loading: false,
      selectedPage: props.selectedPage,
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _isFormValid(){
    let {
      title,
      slug,
      keywords,
      description,
    } = this.state.selectedPage

    let error = null
    if(title == null || title.length === 0){
      error = "Please enter a valid title"
    }
    else if(slug == null || slug.length ===0){
      error = "Please enter a valid page slug"
    }

    if(error){
      this.setState({ error })
      Notify.error(error)
      return false
    }
    return true
  }

  _onClick(){
    let {
      selectedPage,
    } = this.state

    if(selectedPage.id){
      if(selectedPage.static){
        this._updateStaticPage()
      }else{
        this._updatePage()
      }
    }else{
      if(!this._isFormValid()){
        return
      }
      this._addPage()
    }
  }

  _addPage(){
    let {
      selectedPage
    } = this.state

    this.setState({ loading: true })
    Backend.addPage(selectedPage)
      .then(page => {
        this.setState({ loading: false })
        General.showNotification("Page Added");
        General.setLocationHref(Navigation.getUrl(page.slug));
      })
      .catch(error => {
        this.setState({ loading: false })
        General.showNotification(error.message, false);
      })
  }

  _updatePage(){
    let {
      selectedPage
    } = this.state

    this.setState({ loading: true })
    Backend.updatePage(selectedPage)
      .then(page => {
        this.setState({ loading: false })
        General.showNotification("Page Updated");
        this.props.onHide()
      })
      .catch(error => {
        this.setState({ loading: false })
        General.showNotification(error.message, false);
      })
  }

  _updateStaticPage() {
    let {
      website,
      selectedPage
    } = this.state

    const data = {
      slug: website.slug,
      [selectedPage.key]: selectedPage.slug
    }

    this.setState({ loading: true })
    Backend.updateWebsite(data)
      .then(page => {
        this.setState({ loading: false })
        General.showNotification("Page Updated");
        this.props.onHide()
      })
      .catch(error => {
        this.setState({ loading: false })
        General.showNotification(error.message, false);
      })
  }

  render() {
    let {
      show,
      loading,
      selectedPage,
    } = this.state

    let title = selectedPage.id ? "Edit Page" : "Create Page"
    let buttonTitle = selectedPage.id ? "Update" : "Create"
    if(loading){
      buttonTitle = "Loading..."
    }

    return (
      <>
        <PortalModal
          show={show}
          id='icon-picker-modal'
          contentSuperContainerClassName=""
          showAsSideMenu={"false"}
          onHide={() => this.props.onHide()}
          showTopOfAll={true}
          setIdForNonShowAsSideMenu={true}
          customId="page-edit-modal"
        >
          <h3>{title}</h3>

          <div className="row justify-content-center">
            <div className="col-md-12">

              <div className={"mb-3"}>
                <span>
                  Title
                </span>
                <input
                  type="text"
                  value={ selectedPage.title }
                  disabled={ selectedPage.is_homepage || selectedPage.static }
                  onChange={e => {
                    selectedPage.title = e.target.value
                    this.setState({ selectedPage })
                  }}
                  onBlur={() => {
                    if(!selectedPage.slug){
                      selectedPage.slug = slug(selectedPage.title)
                      this.setState({ selectedPage })
                    }
                  }}
                />
              </div>

              <div className={"mb-3"}>
                <span>
                  Page Url
                </span>
                <div>
                  <span>
                    { Website.getDomain(window.CURRENT_WEBSITE) + "/" }
                  </span>
                  <input
                    type="text"
                    name="slug"
                    className="form-control form-control-solid"
                    value={ selectedPage.slug }
                    onChange={e => {
                      selectedPage.slug = slug(e.target.value, {custom: ['/']})
                      this.setState({ selectedPage })
                    }}
                    onBlur={() => {
                      selectedPage.slug = slug(selectedPage.slug, {custom: ['/']})
                      this.setState({ selectedPage })
                    }}
                  />
                </div>
              </div>

              {
                !selectedPage.static &&
                <>
                  <div className={"mb-3"}>
                    <span>
                      Status
                    </span>
                    <Dropdown
                      options={STATUSES}
                      value={STATUSES.find(status => status.value === selectedPage.is_live)}
                      onChange={option => {
                        selectedPage.is_live = option.value
                        this.setState({ selectedPage })
                      }}
                      placeholder="Select An Option"
                    />
                  </div>

                  {
                    !selectedPage.id &&
                    <div className={"mb-3"}>
                      <span>
                        Add To Menu
                      </span>
                      <Dropdown
                        options={ADD_TO_MENU_OPTIONS}
                        value={ADD_TO_MENU_OPTIONS.find(status => status.value === selectedPage.is_in_menu)}
                        onChange={option => {
                          selectedPage.is_in_menu = option.value
                          this.setState({ selectedPage })
                        }}
                        placeholder="Select An Option"
                      />
                    </div>
                  }

                  <div className={"mb-3"}>
                    <span>
                      Description
                    </span>
                    <textarea
                      placeholder={"Description goes here..."}
                      defaultValue={ selectedPage.description }
                      onChange={e => {
                        selectedPage.description = e.target.value
                        this.setState({ selectedPage })
                      }}
                    />
                  </div>

                  <div className={"mb-3"}>
                    <span>
                      Keywords
                    </span>
                    <textarea
                      placeholder={"Comma separated list."}
                      defaultValue={ selectedPage.keywords }
                      onChange={e => {
                        selectedPage.keywords = e.target.value
                        this.setState({ selectedPage })
                      }}
                    />
                  </div>
                </>
              }

              <br/>

              <div className="text-right">
                <a
                  className="btn btn--secondary type--uppercase"
                  onClick={() => this.props.onHide()}
                >
                  <span className="btn__text">
                    Cancel
                  </span>
                </a>
                <button
                  className={`btn btn--primary type--uppercase ${loading ? 'disabled' : ''}`}
                  disabled={loading}
                  onClick={() => {
                    if(!loading) {
                      this._onClick()
                    }
                  }}
                  style={{
                    borderColor: window.CURRENT_PAGE_PRIMARY_COLOR,
                    backgroundColor: window.CURRENT_PAGE_PRIMARY_COLOR
                  }}
                >
                  <span className="btn__text">
                    {buttonTitle}
                  </span>
                </button>
              </div>
            </div>

            {loading &&
              <div className='page-loading-modal'>
                <RotatingLines
                  visible={true}
                  height="96"
                  width="96"
                  strokeWidth="5"
                  strokeColor={window.CURRENT_PAGE_PRIMARY_COLOR}
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                />
              </div>
            }
          </div>
        </PortalModal>
      </>
    )
  }
}
